import * as AppConstants from 'app/AppConstants';
import without from 'lodash/without';

export default (state = [], action) => {
  switch (action.type) {
    case AppConstants.NAVIGATION__LOADED_PAGE_NAVIGATION:
      return action.payload.favorites;
    case AppConstants.FAVORITE__FAVORITED_CARD:
      return state.concat([action.payload.id]);
    case AppConstants.FAVORITE__UNFAVORITED_CARD:
      return without(state, action.payload.id);
    default:
      return state;
  }
};
